<template>
  <div>
    <div class="titleAfter">综合结果</div>
    <div class="item-status">当前状态：最佳状态</div>
    <div class="item-info">
      大脑状态极佳，能感受幸福感的均衡状态。心态心态非常稳定，积极对待每件事情并心存感激，不被外部刺激所动摇。会是一个
      静默恬淡愉悦和乐的一天。每天管理自己的心态，持续维持该状态。
    </div>
    <div>
      <span style="color: #fb6049">建议：</span
      ><span
        >通用标准流程。任何程序都会产生积极的结果。一些特殊的内容或场景也可能会产生情感启发或相应记忆。</span
      >
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.titleAfter {
  position: relative;
  font-weight: bold;
  color: #4aefff;
}
.titleAfter::after {
  content: "";
  position: absolute;
  left: -8px;
  top: 2px;
  width: 3px;
  height: 14px;
  background: #4aefff;
  border-radius: 38px 38px 38px 38px;
}
.item-status {
  margin: 10px 0 20px 0;
}
.item-info {
  line-height: 26px;
  margin-bottom: 20px;
}
</style>
